import React from 'react';
import axios from 'axios';
import { useNavigate, NavLink, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { Button, Grid, Stack, Typography } from '@mui/material';
import { Box, Link } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import { appURL, baseURL } from '../../Data/baseURL';
import CheckboxBasic from '../../Controls/FormsUI/CheckboxBasic';
import Copyright from '../../Apm/Other/Copyright';

import AuthShell from '../../Public/AuthShell';

const axiosInst = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

export default function ActivateUser() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { uid, token } = useParams();
  const [checkedTerms, setCheckedTerms] = React.useState(false);
  const [error, setError] = React.useState(false);

  const handleChange = () => {
    setCheckedTerms(!checkedTerms);
    setError(checkedTerms);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      uid: uid,
      token: token,
    };
    axiosInst
      .post('/auth/users/activation/', body)
      .then((res) => {
        if (res.status === 204) {
          navigate('/apps/login', { replace: true });
          toast.success(() => t('toast.account_sucessfully_activated'));
        }
      })
      .catch((error) => {
        if (
          (error.response &&
            error.response.data &&
            typeof error.response.data === 'object' &&
            !Array.isArray(error.response.data) &&
            error.response.data !== null &&
            Object.values(error.response.data).indexOf('Stale token for given user.') > -1) ||
          (error.response &&
            error.response.data &&
            typeof error.response.data === 'object' &&
            Array.isArray(error.response.data) &&
            error.response.data !== null &&
            error.response.data.find((el) => el.includes('Stale token for given user.')))
        ) {
          toast.error(() => t('toast.activation_code_already_used'), {
            autoClose: 4000,
          });
        } else
          toast.error(() => t('toast.user_not_activated'), {
            autoClose: 4000,
          });
      });
  };

  const handleError = () => {
    setError(true);
  };

  return (
    <React.Fragment>
      <AuthShell mode="activate">
        <Button component={NavLink} to="/" color="primary" size="small" variant="text">
          <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
            <Box sx={{ alignItems: 'flex-end' }}>
              <KeyboardBackspaceIcon />{' '}
            </Box>
            <Typography variant="button">{t('button.back_to_main_page')}</Typography>
          </Stack>
        </Button>

        <Grid container item xs={12} sx={{ mt: 10 }} spacing={2}>
          <Grid item xs={12}>
            <CheckboxBasic
              checked={checkedTerms}
              onChange={handleChange}
              error={error}
              errorMessage={error ? t('terms_and_conditions.please_accept_conditions') : undefined}
              label={
                <>
                  {' '}
                  <Typography variant="body2">
                    {t('terms_and_conditions.accept_conditions_part_1')}
                    <Link href={`${appURL}/terms-conditions`} target="_blank" color="primary">
                      {t('terms_and_conditions.accept_conditions_part_2')}
                    </Link>
                  </Typography>
                </>
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={(e) => (checkedTerms ? handleSubmit(e) : handleError())}
              sx={{ mt: 4, mr: 0, mb: 2 }}
            >
              <Typography variant="button">{t('button.activate')}</Typography>
            </Button>
          </Grid>

          <Grid container item sx={{ mt: 3 }} spacing={1}>
            <Grid item xs={12}>
              <Button component={NavLink} to="/apps/passreset" color="primary" size="small" variant="text">
                <Typography variant="button">{t('button.forgot_password')}</Typography>
              </Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 2 }}>
              <Button component={NavLink} to="/apps/signup" color="primary" size="small" variant="text">
                <Typography variant="button">{t('button.do_not_have_account')}</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Box mt={6}>
          <Copyright />
        </Box>
      </AuthShell>
    </React.Fragment>
  );
}
